<template>
    <div id="header_wrap" class="outer">
        <header class="inner">
            <img id="app_icon" class="lazyload" alt="" data-src="../assets/images/app_icon.jpeg"/>
            <span id="project_title">Tito Control</span>
            <a id="download_link" class="link_button" href="https://titocontrol.oss-cn-hongkong.aliyuncs.com/Tito_Control_v2.5.0.dmg" target="_self" rel="noopener norefferrer">Download Mac v2.5.0</a>
            <a id="view_in_itunes" class="link_button" :href="'https://apps.apple.com/' + country + '/app/tito-control/id1178681856'" target="_blank" rel="noopener norefferrer">View in iTunes</a>
        </header>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data () {
            return {
                country: 'us'
            }
        },
        created () {
            try {
                axios.get('/country', {params: {ip: returnCitySN['cip']}}).then(res => {
                    this.country = res.data.data.country_id.toLowerCase()
                }).catch(_ => {
                })
            } catch (_) {
            }
        }
    }
</script>

<style>
    #header_wrap {
        position: fixed;
        z-index: 10;
        background: #fff;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    #header_wrap .inner {
        max-width: 1000px;
        padding: 30px 10px 30px 10px;
    }

    #app_icon {
        position: absolute;
        width: 32px;
        height: 32px;
        top: 50%;
        transform: translateY(-50%);
        left: 30px;
    }

    #project_title {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 70px;
        font-size: 35px;
        font-weight: 400;
    }

    .link_button {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding: 7px 10px 7px 10px;
        color: #0090ff;
        background: #fff;
        border: solid 1px #0090ff;
        font-size: 15px;
        font-weight: 600;
        border-radius: 6px;
    }

    #download_link {
        right: 160px;
    }

    #view_in_itunes {
        right: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue